export default function MakeTag(props) {
  const tagStyle ={
    borderColor: props.color,
    color: props.color
  }
  
  return (
    <div className="Tag" style={tagStyle}>
      {props.tagText}
    </div>
  );
}